export enum MESSAGE_TYPE {
    TEXT = 'text',
    IMAGE = 'image',
    AUDIO = 'audio',
    VIDEO = 'video',
    DOCUMENT = 'document',
}

export enum SERVICE {
    CALL = 'call',
    EMAIL = 'email',
    SMS = 'sms',
    WA = 'wa',
    WABA = 'waba',
    EVO = 'evo',
    PUSH = 'push',
}

export enum MESSAGE_STATUS {
    PROCESSING = 5,
    VALIDATING = 10,
    VALID = 15,
    SCHEDULED = 20,
    QUEUED = 25,
    CANCELED = 50,
    CANCELED_UNTHORIZED_BY_SENDER = 52,
    CANCELED_NOFUNDS = 54,
    CANCELED_BUSINESS_UNREACHABLE = 56,
    CANCELED_THROTTLE = 58,
    INVALID = 60,
    INVALID_RECIPIENT = 62,
    INVALID_MESSAGE = 64,
    INVALID_MESSAGESIZE = 66,
    INVALID_MESSAGETYPE = 68,
    INVALID_CAPTION = 70,
    INVALID_SERVICE = 72,
    INVALID_DUPLICATEDID = 74,
    INVALID_SCHEDULEDTIME = 76,
    ERROR = 78,
    ERROR_BLOCKED = 80,
    ERROR_TIMEOUT = 82,
    FORWARDED = 100,
    GW_ERROR = 105,
    GW_SENT = 200,
    GW_CONFIRMED = 210,
    GW_UNKNOWN = 255,
    GW_RETRY = 195,
}
